<template>
    <v-expand-transition accordition>
        <v-card v-show="show" class="theme-back" :class="{ over: isOver }" tile flat :disabled="gamefinished||disabled">
            <v-list class="theme-back">
                <v-list-item-group color="primary" v-model="selectedPlayer" :style="{direction: (side && (side === 'left')) ? 'rtl' : 'ltr'}">
                    <v-card v-if="isOver" @click="closeOfficials" tile flat class="toggle-btn theme-background theme-border">
                        <v-icon class="t-icon theme-text">mdi-chevron-down</v-icon>
                        <span class="t-text theme-text">Játékosok</span>
                    </v-card>
                    <v-card v-if="isOver" tile flat class="toggle-btn list-title theme-border">
                        <span class="t-text theme-title">Hivatalos személyek</span>
                    </v-card>
                    <v-list-item
                        v-for="i in itemCount"
                        :key="id+'_'+i"
                        class="player-item theme-background"
                        :class="[(id === 'staffA' || id === 'staffB') ? 'official' : '', (getPerson(i) && getPerson(i).goalkeeper) ? 'isGoalkeeper' : '']"
                        active-class="player-selected"
                        @click="setPicker(getPerson(i))"
                        :disabled="gamefinished || ($refs['player' + i] && $refs['player' + i][0].isDisabled) || (gamedata.rule === 'STRAND' && i > 10)"
                    >
                        <Player :gamefinished="gamefinished" v-if="((gamedata.rule === 'STRAND' && i <= 10) || gamedata.rule === 'TEREM') && getPerson(i)" :player="getPerson(i)" :teamid="id" :ref="'player' + i" :actualGoalKeeper="actualGoalKeeper" :gamedata="gamedata"/>
                        <PlayerEntry :gamefinished="gamefinished" v-else-if="gamedata.rule === 'TEREM'"/>
                        <PlayerSpace v-else/>
                    </v-list-item>
                </v-list-item-group>
            </v-list>
            <GoalKeeperModal v-if="show" v-show="showGoalKeeperModal" :goalkeepers="goalkeepers" :position="position" :player="selectedPlayer" :hotkeys="hotkeys" :teamId="id" :actualGoalKeeper="actualGoalKeeper" :isActive="isActive"/>
            <PlayerPicker v-if="team" :overlay="showPicker" :players="playerEntry" :team="team" :takenJerseys="takenJerseyNumbers" screen="report"/>
        </v-card>
    </v-expand-transition>
</template>

<script>
    import Player from "@/components/Player";
    import PlayerEntry from "@/components/PlayerEntry";
    import PlayerSpace from "@/components/PlayerSpace";
    import PlayerPicker from "@/components/PlayerPicker";
    import GoalKeeperModal from "@/components/GoalKeeperModal";
    import CONSTANTS from '@/constants';
    import eventBus from '@/eventBus';
    import {mapMutations, mapState} from "vuex";

    import busListeners from "@/mixins/busListeners";

export default {
    mixins: [busListeners],
        name: 'PlayerList',
        components: {
            Player,
            PlayerEntry,
            PlayerSpace,
            PlayerPicker,
            GoalKeeperModal
        },
        props: [
            'persons',
            'isOver',
            'show',
            'itemCount',
            'id',
            'team',
            'isActive',
            'playerEntry',
            'actualGoalKeeper',
            'gamedata',
            'gamefinished',
            'hotkeys',
            'side'
        ],
        data: function() {
            return {
                selectedPlayer: undefined,
                disabled: false,
                goalkeepers: [],
                showGoalKeeperModal: false,
                position: {
                    top: 0,
                    left: 0,
                    right: 0,
                },
            }
        },
        created() {
            let self = this;
            this.$busOn('disable' + this.id, function(value) {
                self.disabled = value;
                if (self.gamedata.rule === "STRAND") {
                  self.disabled = false;
                }
            });
            this.$busOn(CONSTANTS.EVENTS.SHOWGOALKEEPERMENU, function(position, teamId) {
              console.log(position, teamId);
                if(teamId === self.id) {
                    self.position = position;
                    self.goalKeeperModal(true);
                }
            });
            this.$busOn(CONSTANTS.ACTIONS.CLOSE.MODAL, function() {
                self.goalKeeperModal(false);
            });
            this.$busOn(CONSTANTS.ACTIONS.HIDEPICKER,function(){
                self.SET_SHOW_PICKER(false);
                self.selectedPlayer = undefined;
                self.selectedTeam = undefined;
                eventBus.$emit(CONSTANTS.EVENTS.CHANGE.DIALOG, false)
            });
            this.$busOn(CONSTANTS.EVENTS.RECORD.CREATED, function () {
                self.selectedPlayer = undefined;
                self.selectedTeam = undefined;
                if (self.gamedata.rule !== "STRAND") {
                  self.disabled = window.stopwatch.getTime() == 0;
                } else {
                  self.disabled = false;
                }
            });
            this.$busOn(CONSTANTS.ACTIONS.RESTORE.SELECTION, function (record) {
                if(record) {
                    let index = self.sortedPersonList.findIndex(elem => elem.id === record.selectedPlayer);
                    if(index !== -1) {
                        self.selectedPlayer = index;
                        self.disabled = false;
                    }
                    else {
                        self.selectedPlayer = undefined;
                    }
                }
            });
        },
        methods: {
            ...mapMutations('ui', ['SET_SHOW_PICKER']),
            goalKeeperModal(status) {
                this.showGoalKeeperModal = status;

            },
            setPicker(person) {
                if(typeof person === 'undefined') {
                    this.SET_SHOW_PICKER(true);
                    eventBus.$emit(CONSTANTS.EVENTS.CHANGE.DIALOG, true);
                }
            },
            closeOfficials() {
                eventBus.$emit(CONSTANTS.ACTIONS.CLOSE.OFFICIALSLIST, this.team);
            },
            getPerson(i) {
                return this.sortedPersonList[i-1];
            },
        },
        watch: {
            selectedPlayer: function(newValue, oldValue) {
                if(newValue !== oldValue) {
                    // sajnos nem tudok jobb megoldást rá, mint beégetni
                    if(this.id === "teamA" || this.id === "staffA") {
                        eventBus.$emit(CONSTANTS.ACTIONS.DISABLE.TEAM.B, newValue !== undefined);
                        eventBus.$emit(CONSTANTS.ACTIONS.DISABLE.STAFF.B, newValue !== undefined);
                    }
                    else {
                        eventBus.$emit(CONSTANTS.ACTIONS.DISABLE.TEAM.A, newValue !== undefined);
                        eventBus.$emit(CONSTANTS.ACTIONS.DISABLE.STAFF.A, newValue !== undefined);
                    }
                }

                // Akkor is mennie kell eventnek, ha null vagy undefined,
                // hiszen ez az event szabadítja fel a komponens blokkolásokat
                let teamId = (this.sortedPersonList[newValue] === null || this.sortedPersonList[newValue] === undefined) ? null : this.id;
                let playerId = (this.sortedPersonList[newValue] === null || this.sortedPersonList[newValue] === undefined) ? null : this.sortedPersonList[newValue].id;
                eventBus.$emit(CONSTANTS.ACTIONS.SELECTED.TEAM, teamId);
                eventBus.$emit(CONSTANTS.ACTIONS.SELECTED.PLAYER, playerId);
            }
        },
        computed: {
            ...mapState('ui', ['showPicker']),
            sortedPersonList() {
                let self = this;
                let persons = [];
                let person = {};
                self.goalkeepers = [];
                for (person in this.persons) {
                    persons.push(this.persons[person]);
                    if(this.persons[person].goalkeeper && this.gamedata.rule !== "STRAND") {
                        self.goalkeepers.push(this.persons[person]);
                    } else if (this.gamedata.rule === "STRAND") {
                      self.goalkeepers.push(this.persons[person]);
                    }
                }

                persons.sort(function(a,b){
                    return (a.jersey === b.jersey) ? 0 : (a.jersey < b.jersey) ? -1 : 1;
                });

                if(persons.length) {
                    persons.sort(function(a,b){
                        return (a.goalkeeper === b.goalkeeper) ? 0 : a.goalkeeper ? -1 : 1;
                    });
                }

                return persons;
            },
            takenJerseyNumbers() {
                let jerseyList = [];

                this.sortedPersonList.forEach(player => {
                    if(player.jersey) {
                        jerseyList.push(player.jersey);
                    }
                });

                return jerseyList;
            }
        }
    }
</script>

<style scoped>
    .v-card {
        transition-property: unset;
        height: 100%;
        width: 100%;
    }

    .v-list {
        width: 100%;
        height: 100%;
        padding: 0;
    }

    .v-list-item-group {
        display: flex;
        flex-flow: column;
        justify-content: stretch;
        height: 100%;
        overflow: auto;
        scrollbar-width: thin;
    }

    .v-list-item {
        padding: 0;
        /*min-height: unset;*/
        min-height: calc(6.25% - 0.5px);
        height: calc(6.25% - 0.5px);
        max-height: calc(6.25% - 0.5px);
        direction: ltr;
    }

    .v-list-item.official {
        height: calc(6.25% - 0.5px);
        min-height: calc(6.25% - 0.5px);
        max-height: calc(6.25% - 0.5px);
    }

    .v-list-item__content {
        height: 100%;
        width: 100%;
        padding: 0;
    }

    .over {
        position: absolute;
        z-index: 1;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }

    .toggle-btn {
        flex-grow: 0;
        flex-shrink: 1;
        flex-basis: calc(6.25% - 0.5px);
        min-height: 42px;
        width: 100%;
        display: flex;
        flex-flow: row;
        flex-direction: row;
        align-items: center;
        flex-wrap: nowrap;
        text-decoration: none;
        text-align: left;
        padding: 0 10px;
        border-style: solid;
    }

    .toggle-btn:not(.list-title) {
        border-left-width: 1px !important;
        border-right-width: 1px !important;
        border-top-width: 0 !important;
        border-bottom-width: 1px !important;
    }

    .toggle-btn.list-title {
        background-color: transparent !important;
        justify-content: center;
        border-left-width: 0 !important;
        border-right-width: 0 !important;
        border-top-width: 0 !important;
        border-bottom-width: 1px !important;
    }

    .toggle-btn > .t-text {
        font-size: 12px;
        font-weight: normal;
        font-stretch: condensed;
        font-family: 'Roboto Condensed';
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
    }

    .toggle-btn > .t-icon {
        font-size: 20px;
        margin-right: 8px;
    }

    .isGoalkeeper + .player-item:not(.isGoalkeeper) {
        margin-top: 8px;
    }

    .isGoalkeeper + .player-item:not(.isGoalkeeper) .player-btn {
        border-top-width: 1px !important;
    }

    .player-selected .player-btn.theme--light {
        background-color: #a6ffc3 !important;
    }

    .player-selected .player-btn.theme--dark {
        background-color: #23C373 !important;
    }
</style>
